var _polygon, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#FFCD00",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#FFCD00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "noEntryIconTitle"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "16 3 21 8 21 16 16 21 8 21 3 16 3 8 8 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 7,
    y: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntry);
export default __webpack_public_path__ + "static/media/no-entry.06071c5f26b76c781cfa7e76a71911b0.svg";
export { ForwardRef as ReactComponent };